import Vue from "vue";
import Vuex from "vuex";

// Modules

import app from "./app";
import appConfig from "./app-config";
import verticalMenu from "./vertical-menu";
import user from "@/router/routes/user";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    auth: null,
  },
  getters: {
    isAuthenticated: (state) => state.auth !== null,
    user: (state) => state.auth,
  },
  mutations: {
    SET_AUTH(state, auth) {
      state.auth = auth;
    },
  },
  actions: {
    setAuth({ commit }, auth) {
      commit("SET_AUTH", auth);
    },
  },
  modules: {
    app,
    appConfig,
    verticalMenu,
  },
  strict: process.env.DEV,
});
